// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ContactInfo-module-nameAndPhoneList-1g1UM{display:grid;grid-gap:6px;gap:6px}.ContactInfo-module-nameAndPhoneList-1g1UM strong{margin-inline-end:5px}.ContactInfo-module-label-3f5sS{font-weight:var(--weight-bold);margin-inline-end:6px}.ContactInfo-module-editButton-1Qk6s{margin-top:20px}", ""]);
// Exports
exports.locals = {
	"nameAndPhoneList": "ContactInfo-module-nameAndPhoneList-1g1UM",
	"label": "ContactInfo-module-label-3f5sS",
	"editButton": "ContactInfo-module-editButton-1Qk6s"
};
module.exports = exports;
